import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import propTypes from 'prop-types';
import { MdCheck, MdContentCopy } from 'react-icons/md';
import * as S from './styles';

const CodeBlock = ({ title, code }) => {
  const [t] = useTranslation('personalized-invite');
  const [isCopied, setIsCopied] = useState(false);

  // Permissão negada mantém o botão em "Copiar": o dev ainda seleciona o texto à mão
  const handleCopy = () =>
    navigator.clipboard
      ?.writeText(code)
      .then(() => setIsCopied(true))
      .catch(() => setIsCopied(false));

  return (
    <S.Wrapper>
      <S.Header>
        <S.Title>{title}</S.Title>
        <S.CopyButton type="button" onClick={handleCopy}>
          {isCopied ? <MdCheck size={16} /> : <MdContentCopy size={16} />}
          {isCopied
            ? t('generator.actions.copied')
            : t('generator.actions.copy')}
        </S.CopyButton>
      </S.Header>
      <S.Code>{code}</S.Code>
    </S.Wrapper>
  );
};

CodeBlock.propTypes = {
  title: propTypes.string.isRequired,
  code: propTypes.string.isRequired,
};

export default CodeBlock;
